import { render, staticRenderFns } from "./Workflow-view.vue?vue&type=template&id=039b31ac"
import script from "./Workflow-view.vue?vue&type=script&lang=js"
export * from "./Workflow-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports